"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ArrowRight } from "lucide-react";

export default function LoyaltyCta() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-redy-charcoal text-white overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(244,114,43,0.25) 0%, transparent 60%)" }}
      />

      <div className="relative max-w-[800px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-6" style={{ color: "#F4722B" }}>
            {t("The list is your moat.", "La lista es tu moat.")}
          </div>
          <h2 className="text-4xl md:text-[72px] font-black tracking-[-0.03em] leading-[1.02] mb-8">
            {t("Build it.", "Constrúyela.")}
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #FCA17D 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("Bring them back.", "Tráelos de vuelta.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[520px] mx-auto leading-relaxed mb-10">
            {t(
              "Points and rewards tracked by phone. A customer database that grows with every order. SMS to the customers who opted in. Captured on your page, not a marketplace's.",
              "Puntos y premios por teléfono. Una base de clientes que crece con cada orden. SMS a los clientes que aceptaron. Capturada en tu página, no en la de un marketplace."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/signup"
              className="group inline-flex items-center gap-2 text-[15px] font-bold px-8 py-4 rounded-full hover:scale-[1.03] transition-transform shadow-2xl text-white"
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #D7263D 100%)",
                boxShadow: "0 20px 60px rgba(244, 114, 43, 0.5)",
              }}
            >
              {t("Start owning your list →", "Empieza a poseer tu lista →")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/solution/restaurants"
              className="inline-flex items-center text-[14px] font-bold text-white/70 hover:text-white transition-colors px-4 py-2"
            >
              {t("See the full restaurant pitch →", "Ver el pitch completo →")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
